/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Auto_Soon_1Inputs */

const en_simple_door_auto_soon_1 = /** @type {(inputs: Simple_Door_Auto_Soon_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The automatic route is opening gradually for early users.`)
};

const id_simple_door_auto_soon_1 = /** @type {(inputs: Simple_Door_Auto_Soon_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalur otomatis sedang dibuka bertahap untuk peserta awal.`)
};

/**
* | output |
* | --- |
* | "The automatic route is opening gradually for early users." |
*
* @param {Simple_Door_Auto_Soon_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_auto_soon_1 = /** @type {((inputs?: Simple_Door_Auto_Soon_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Auto_Soon_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_auto_soon_1(inputs)
	return en_simple_door_auto_soon_1(inputs)
});